import React from "react";
// import Notifications from "components/Notifications/Notifications";
// import { useLocation } from "react-router-dom";
import { Navbar, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "assets/img/logos/TopCXLogo/logo.png";
import { useAuth } from "context/AuthContext";

const NavbarTop = () => {
  const { logout } = useAuth();
  // const user = JSON.parse(sessionStorage.getItem("topCXDataAdmin"));
  
  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };
  
  return (
    <div className="my-1">
      <Navbar expand="lg" className="bg-body-tertiary">
        <Navbar.Brand>
          <img
            src={logo}
            alt="Logo"
            style={{ maxWidth: "12rem", maxHeight: "12rem" }}
            width={90}
          />
        </Navbar.Brand>

        <div className="ms-auto d-flex align-items-center me-2">
          {/* <Notifications /> */}
          <Button 
            variant="outline-danger" 
            size="sm" 
            onClick={handleLogout}
            className="ms-2"
          >
            <FontAwesomeIcon icon="sign-out-alt" className="me-1" />
            Logout
          </Button>
        </div>
      </Navbar>
    </div>
  );
};

export default NavbarTop;
